module.exports = __webpack_public_path__ + "img/photo-alt.8cf345cd.svg";